import { css } from '@emotion/css';

import { listItemHoverStyles } from '@/utils/styles';

export const listItemRootStyles = css`
  :hover .admin-list-item {
    ${listItemHoverStyles}
  }
`;
